import Toggle from './Toggle.jsx';
import React from 'react';

const OptionToggle = ({ value, onChange, title, description, toggleFirst, className }) => {
    return (
        <div className={`flex items-center ${toggleFirst ? 'flex-row-reverse gap-x-4' : 'justify-between'} ${className}`}>
            <div className="flex-1 mr-3">
                <div>{title}</div>
                <div className="text-sm text-gray-500">{description}</div>
            </div>
            <div>
                <Toggle enabled={value} setEnabled={onChange} />
            </div>
        </div>
    );
};

export default OptionToggle;
